import React from 'react'
import {Link} from 'react-router-dom'

const Breadcrumbs = ({className, breadcrumbList}) => {
  return (
    <div className={className}>{
        breadcrumbList.map((breadcrumb, i) => i == breadcrumbList.length - 1 ? <div key={breadcrumb.link} className='breadcrumbs-link'>{breadcrumb.text} </div>: <Link key={breadcrumb.link} className='breadcrumbs-link' to={breadcrumb.link}>{breadcrumb.text}&nbsp;&nbsp;/&nbsp;&nbsp;</Link>)
      }</div>
  )
}

export default Breadcrumbs